// extracted by mini-css-extract-plugin
module.exports = {"summary-data-box":"_1sn4ayWH9hZ-l3DCZBa4Bi","title-center":"KJ03dOyc7vFMqE0KDX7M3","amount":"gqeYT69Pd5xC_QYOSB1HU"};